import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {isNotNullOrUndefined} from "../../providers/service/global-variables.service";

@Component({
    selector: 'app-huna-button',
    templateUrl: './huna-button.component.html',
    styleUrls: ['./huna-button.component.scss'],
    standalone: false
})
export class HunaButtonComponent implements OnInit, AfterViewInit {
    @ViewChild('size', {static: false}) sizeButton: any;


    @Input()
    color: 'primary' | 'accent' | 'warn' | '' = 'primary';
    @Input()
    type: 'mat-flat-button' | 'mat-raised-button' | 'mat-stroked-button' | 'mat-icon-button' | 'mat-fab' | 'mat-mini-fab' = 'mat-flat-button';
    @Input()
    loading: boolean | undefined|null = false;
    @Input()
    disabled = false;


    constructor() {
    }

    ngOnInit(): void {
    }

    sizeDivSpinner = 70;

    ngAfterViewInit(): void {
        if (isNotNullOrUndefined(this.sizeButton) && isNotNullOrUndefined(this.sizeButton._elementRef) && typeof this.sizeButton._elementRef.nativeElement.clientWidth === 'number') {
            this.sizeDivSpinner = this.sizeButton._elementRef.nativeElement.clientWidth;
        }
    }


}
